import { Timestamp } from 'firebase/firestore';

export class DashboardNotification {
  public icon: string;
  public link: string;
  public title: string;
  public message: string;
  public timestamp: Timestamp;
  public readAtTime: Timestamp;
  public id: string;

  constructor(icon, link, title, message, timestamp, readAtTime, id) {
    this.icon = icon;
    this.link = link;
    this.title = title;
    this.message = message;
    this.timestamp = timestamp;
    this.readAtTime = readAtTime;
    this.id = id;
  }
}
